import React from "react"

import Layout from "../components/layout"
import Snippet from "../components/snippet"
import SpeakerCard from "../components/speakerCard"
import SnippetCard from "../components/snippetCard"

import style from "./index.module.css"
import layoutStyle from "../components/layout.module.css"

const IndexPage = () => (
	<Layout
		meta={{
			title: "Dev/Java/JavaScript",
			description:
				"Accento is an amazing Java/JavaScript conference in Karlsruhe, Germany, on Sep 24th/25th 2019.",
			keywords: "Java conference Karlsruhe",
			path: "/",
		}}
		wide
	>
		<Snippet id="landing-past" />

		<Snippet id="landing-accento" />

		<Snippet id="landing-quick-dirty" />

		<div>
			<Snippet id="landing-talks" />
			<div className={layoutStyle.cards}>
				<SpeakerCard
					speakerSlug="ted-neward"
					size="medium"
					linkImage
					showName
					linkName
					showTalks
				/>
				<SpeakerCard
					speakerSlug="simon-ritter"
					size="medium"
					linkImage
					showName
					linkName
					showTalks
				/>
				<SpeakerCard
					speakerSlug="christoph-engelbert"
					size="medium"
					linkImage
					showName
					linkName
					showTalks
				/>
			</div>
		</div>

		<div>
			<Snippet id="landing-trainings" />
			<div className={layoutStyle.cards}>
				<SpeakerCard
					speakerSlug="robert-scholte"
					size="medium"
					linkImage
					showName
					linkName
					showTrainings
				/>
				<SpeakerCard
					speakerSlug="peter-kroener"
					size="medium"
					linkImage
					showName
					linkName
					showTrainings
				/>
				<SpeakerCard
					speakerSlug="ruediger-zu-dohna"
					size="medium"
					linkImage
					showName
					linkName
					showTrainings
				/>
			</div>
		</div>

		<Snippet id="landing-party" />

		<div>
			<Snippet id="landing-tickets" />
			<div className={`${layoutStyle.cards} ${style.tickets}`}>
			<SnippetCard
					size="medium"
					imageSlug="duke"
					snippetId="ticket-conference"
					className={style.ticket}
				/>
				<SnippetCard
					size="medium"
					imageSlug="dukestudent"
					snippetId="ticket-student"
					className={style.ticket}
				/>
				<SnippetCard
					size="medium"
					imageSlug="barbell"
					snippetId="ticket-training"
					className={style.ticket}
				/>
				<SnippetCard
					size="medium"
					imageSlug="dukebell"
					snippetId="ticket-combi"
					className={style.ticket}
				/>
			</div>
			<Snippet id="landing-jcon" />
		</div>

		<Snippet id="landing-contact" />
	</Layout>
)

export default IndexPage
